// @flow
import {BaseApi as CommonApi} from '@userstory/api';
import type {TApiRequestOptions} from '@userstory/api';

function getOptions(options, method) {
    const result = {...options};

    if (!result.headers) {
        result.headers = {};
    }

    let credentials = 'include';
    if (result.headers['X-CLUSTER-AUTH']) {
        // если есть такой заголовок, происходит кросдоменный запрос, куки не передаем
        credentials = 'omit';
    }

    return {
        ...result,
        credentials,
        headers: {
            ...result.headers,
            'X-HTTP-METHOD-OVERRIDE': method,
        },
        method: 'POST',
    };
}

class BaseApi extends CommonApi {
    post(url: string, options?: TApiRequestOptions) {
        return this.request(url, getOptions(options, 'POST'));
    }

    get(url: string, options?: TApiRequestOptions) {
        return this.request(url, getOptions(options, 'GET'));
    }

    put(url: string, options?: TApiRequestOptions) {
        return this.request(url, getOptions(options, 'PUT'));
    }

    delete(url: string, options?: TApiRequestOptions) {
        return this.request(url, getOptions(options, 'DELETE'));
    }

    patch(url: string, options?: TApiRequestOptions) {
        return this.request(url, getOptions(options, 'PATCH'));
    }
}

export {BaseApi};
